import { apiError, fetchWithRetry, wrapFetch } from './api';

/**
 * Reads the version and the environment of the backend the panel talks to,
 * from Spring's `/actuator/info`
 *
 * @returns {Promise<{ environment?: string, build?: { version?: string } }>}
 */
export function getAppInfo() {
  const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

  return wrapFetch(
    fetchWithRetry(`${BASE_URL}/actuator/info`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }),
    apiError(),
  );
}
